class Monitoring.Views.PreviewView extends Backbone.View
  template: JST["backbone/templates/monitoring/topic_admin/preview"]
  tweet_template: JST["backbone/templates/monitoring/topic_admin/preview_tweet"]

  initialize: (@options = {}) ->

  render: ->
    @$el.html(@template({}))
    @$el.modal()
    @$el.on('hide', @onHide)
    @preview()
    return this

  onHide: =>
    clearTimeout(@contentTimeout) if @contentTimeout
    @remove()
    $.ajax
      url: "/monitoring/preview/stop/"
      type: 'POST'
      data:
        uuid: @uuid
      dataType: "json"

  preview: ->
    clearTimeout(@contentTimeout)
    @uuid = Monitoring.Models.RandomStringGenerator.generateNewUuid()

    @$el.find('#preview_btn').attr('disabled', true)
    $.ajax
      url: "/monitoring/preview/start/"
      type: 'POST'
      data:
        @_getFormData()
      success: (response) =>
        @getContent()
      complete: () =>
        @$el.find('#preview_btn').attr('disabled', false)
      dataType: "json"

  _getFormData: -> # Hack to remove all ids from elements because they break server when creating new Topic using Topic.new(params['keepcon_topic'])
    return $.param(_.filter($('form').serializeArray(), (element) ->
      return !element.name.match(/keepcon_source\[.+?\]\[\d+\]\[id\]/g)
    )) + "&uuid=#{@uuid}"

  getContent: =>
    @contentTimeout = setTimeout =>
      $.ajax
        url: "/monitoring/preview/get/"
        type: 'POST'
        data:
          uuid: @uuid
        success: (response) =>
          _.each($.parseJSON(response.content), @addToPreviewContent)
          streaming = @$el.find('#streaming')
          streaming.children().css('width', (response.progress * 100) + '%')
          if !response.finished
            @getContent()
          else
            streaming.removeClass('active')
            streaming.addClass('progress-danger')
            streaming.children().text('Stopped')
        error: () =>
          @getContent()
        dataType: "json"
    , 1000

  addToPreviewContent: (content) =>
    tweet = new Monitoring.Models.SocialContents.TwitterContent({data: content})
    @$el.find('#preview_content').prepend(@tweet_template(tweet))

  destroy: ->
    @remove()
    return false
